module.exports = __webpack_public_path__ + "img/usa_bank.4a41f8be.png";